/* eslint-disable no-unused-vars */
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useQuery } from "react-query";
import Navigator from "../../../layouts/Navigator/Navigator";
import AddPowerGroup from "../../../components/Mc12/AddPowerGroup/AddPowerGroup.component";

import {
  selectMc12Steps,
  selectIsTrackClosed,
  selectNbSegments,
  selectAccessories,
  selectPowerSupplies,
  selectCalculatedElectricalInstallation,
  setCalculatedElectricalInstallation,
  setMc12CurrentStep,
  selectShouldRecalculateElectricalInstallation,
  setShouldRecalculateElectricalInstallation
} from "../../../store/slices/mc12";
import { getProductImgUrl } from "../../../utils/common/api/api";
import t from "../../../utils/common/translation/translator";
import {
  calculateNbPsInPowerGroups,
  genElectricalInstallation,
  genPowerGroup,
  getMaxPowerSupplies,
  getNeededPowerGroups
} from "../../../utils/Mc12/func.utils";
import PowerGroup from "../../../components/Mc12/PowerGroup/PowerGroup.component";
import { updateConfiguration } from "../../../store/slices/common";

const ElectricalInstallation = () => {
  const dispatch = useDispatch();
  const mc12Steps = useSelector(selectMc12Steps);
  const isTrackClosed = useSelector(selectIsTrackClosed);
  const nbSegments = useSelector(selectNbSegments);
  const calculatedElectricalInstallation = useSelector(selectCalculatedElectricalInstallation);
  const accessories = useSelector(selectAccessories);
  const powerSupplies = useSelector(selectPowerSupplies);
  const shouldRecalculateEI = useSelector(selectShouldRecalculateElectricalInstallation);

  useEffect(() => {
    // getting ncessary information about power groups
    const nbNeededPowerSupply =
      Math.ceil(nbSegments / 8) > getMaxPowerSupplies() ? getMaxPowerSupplies() : Math.ceil(nbSegments / 8);
    const neededPowerGroups = getNeededPowerGroups(nbNeededPowerSupply);

    if (shouldRecalculateEI) {
      // init Electrical Installation
      const tmpElectricalInstallation = genElectricalInstallation(accessories);

      //Init power groups
      const powerGroups = [];
      for (let i = 0; i < neededPowerGroups.length; i++) {
        const powerGroup = genPowerGroup(powerSupplies, accessories);
        powerGroup.id = i + 1;
        powerGroup.powerSupply.quantity = neededPowerGroups[i];
        powerGroup.connectionModule.quantity = neededPowerGroups[i];
        powerGroup.powerInterPlug.quantity = neededPowerGroups[i];
        const defaultPowerCableIndex = powerGroup.powerCables.findIndex((cable) => cable.length === 6);
        if (defaultPowerCableIndex !== -1) {
          powerGroup.powerCables[defaultPowerCableIndex].quantity = neededPowerGroups[i];
        }
        powerGroups.push(powerGroup);
      }

      tmpElectricalInstallation.powerGroups = powerGroups;

      // Number of power disconnectors between segments
      if (isTrackClosed) {
        tmpElectricalInstallation.powerDisconnector.quantity =
          tmpElectricalInstallation.powerGroups.length === 1 ? 0 : tmpElectricalInstallation.powerGroups.length;
      } else {
        tmpElectricalInstallation.powerDisconnector.quantity = tmpElectricalInstallation.powerGroups.length - 1;
      }

      // Number of "Power Interconnects"
      const numberOfPowerInterconnects = tmpElectricalInstallation.powerGroups.reduce(
        (acc, curr) => acc + curr.powerInterPlug.quantity,
        0
      );
      let powerInterconnectsQuantity = 0;
      if (isTrackClosed) {
        powerInterconnectsQuantity =
          nbSegments - numberOfPowerInterconnects - tmpElectricalInstallation.powerDisconnector.quantity;
      } else {
        powerInterconnectsQuantity =
          nbSegments - numberOfPowerInterconnects - tmpElectricalInstallation.powerDisconnector.quantity + 1;
      }
      // const piece_10_quantity = Math.floor(powerInterconnectsQuantity / 10);
      // const piece_1_quantity = Math.ceil(powerInterconnectsQuantity % 10);
      const piece_1_quantity = powerInterconnectsQuantity;
      const piece_1_index = tmpElectricalInstallation.powerInterSeg.findIndex((p) => p.quantityPerSet === "1_PIECE");
      // const piece_10_index = tmpElectricalInstallation.powerInterSeg.findIndex((p) => p.quantityPerSet === "10_PIECES");
      tmpElectricalInstallation.powerInterSeg[piece_1_index].quantity = piece_1_quantity;
      // tmpElectricalInstallation.powerInterSeg[piece_10_index].quantity = piece_10_quantity;
      dispatch(setCalculatedElectricalInstallation(tmpElectricalInstallation));
      dispatch(setShouldRecalculateElectricalInstallation(false));
    }
  }, []);

  return (
    <div className="flex flex-col pt-5">
      <span className=" text-gray-400 font-normal text-sm">{t("mc12.ui.step.electrical.title.powersuply.number")}</span>
      <hr className="border-gray-300 border-1 my-5" />
      <div className="flex flex-row md:grow md:flex-col gap-3">
        {calculatedElectricalInstallation?.powerGroups?.map((powerGroup, index) => (
          <PowerGroup key={powerGroup.id} id={powerGroup.id} index={index} />
        ))}
        <div className="flex items-center">
          <div className="bg-gray-200 w-full h-[1px]"> </div>
          <div className="flex w-full justify-center items-center gap-x-3">
            <img
              src={getProductImgUrl(
                calculatedElectricalInstallation?.powerInterSeg
                  ? calculatedElectricalInstallation?.powerInterSeg[0]?.commercialReference
                  : null
              )}
              alt=""
              className="w-16"
            />
            <span className="text-lg">
              {calculatedElectricalInstallation?.powerInterSeg?.reduce((a, b) => {
                if (b.quantityPerSet === "10_PIECES") {
                  return a + b.quantity * 10;
                } else {
                  return a + b.quantity;
                }
              }, 0)}
            </span>
            <span className="text-sm">{t("mc12.ui.step.track.electrical.power_interconnect_segment")}</span>
          </div>
          <div className="bg-gray-200 w-full h-[1px]"> </div>
        </div>
        <AddPowerGroup
          disabled={
            calculateNbPsInPowerGroups(calculatedElectricalInstallation.powerGroups) >= getMaxPowerSupplies(nbSegments)
          }
        />
      </div>
      <Navigator
        continueAction={() => {
          dispatch(setMc12CurrentStep(mc12Steps.COMMUNICATION));
          dispatch(updateConfiguration());
        }}
      />
    </div>
  );
};

export default ElectricalInstallation;
